import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initializeSentry } from '@config/sentry';
import App from '@app/App.tsx';

import '@app/main.scss';

// Initialize Sentry before React renders to capture all errors
initializeSentry();

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
